import { useMemo } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import StudentDashboard from "./dashboards/StudentDashboard";
import TutorDashboard from "./dashboards/TutorDashboard";

function useAuth() {
  return useMemo(() => {
    try { return JSON.parse(localStorage.getItem("auth") || "null"); }
    catch { return null; }
  }, []);
}

function RoleRedirect() {
  const auth = useAuth();
  if (!auth) return <Navigate to="/login" replace />;
  const role = (auth.role || "student").toLowerCase();
  return <Navigate to={`/dashboard/${role}`} replace />;
}

function RequireRole({ role, children }) {
  const auth = useAuth();
  if (!auth) return <Navigate to="/login" replace />;
  const current = (auth.role || "student").toLowerCase();
  if (current !== role) return <Navigate to={`/dashboard/${current}`} replace />;
  return children;
}

export default function DashboardRouter() {
  return (
    <Routes>
      <Route index element={<RoleRedirect />} />
      <Route
        path="student"
        element={
          <RequireRole role="student">
            <StudentDashboard />
          </RequireRole>
        }
      />
      <Route
        path="tutor"
        element={
          <RequireRole role="tutor">
            <TutorDashboard />
          </RequireRole>
        }
      />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}